import React from 'react';
import { Accordion, Container } from 'react-bootstrap';

export default function FaqSection({ faqs = [], loading }) {
  return (
    <section className="mm-section" id="faq">
      <Container>
        <div className="text-center mb-5">
          <div className="mm-eyebrow mb-2">FAQ</div>
          <h2 className="mm-h2">Common questions</h2>
          <p className="mm-lead mt-3 mx-auto" style={{ maxWidth: '48ch' }}>
            The things people ask us most often before booking their first
            session.
          </p>
        </div>

        {loading ? (
          <div className="mm-faq">
            {Array.from({ length: 4 }, (_, i) => (
              <div className="mm-skeleton mb-3" key={`faq-skeleton-${i}`}>
                <div className="mm-skeleton__bar" style={{ width: '55%', margin: 0 }} />
              </div>
            ))}
          </div>
        ) : (
          // defaultActiveKey opens the first question — the accordion reads as
          // dead furniture when everything starts collapsed.
          <Accordion className="mm-faq" defaultActiveKey="0">
            {faqs.map((faq, index) => (
              <Accordion.Item eventKey={String(index)} key={faq.id ?? index}>
                <Accordion.Header>{faq.question}</Accordion.Header>
                <Accordion.Body>{faq.answer}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        )}
      </Container>
    </section>
  );
}
